var _path, _path2, _g, _rect, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBannerShape(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 672,
    height: 649,
    viewBox: "0 0 672 649",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H672V649H140C62.6801 649 0 586.32 0 509V0Z",
    fill: "#FDB426"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_446_7793",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 672,
    height: 649
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H672V649H140C62.6801 649 0 586.32 0 509V0Z",
    fill: "#FDB426"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_446_7793)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_446_7793)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 487,
    cy: 223,
    r: 278,
    fill: "#B5AEC8",
    fillOpacity: 0.51
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    clipPath: "url(#clip0_446_7793)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_446_7793",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -320,
    y: -155,
    width: 1040,
    height: 692
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -320,
    y: -155,
    width: 1040,
    height: 692,
    fill: "url(#paint0_diamond_446_7793)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_446_7793)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.11
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_446_7793)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9104 -77.1694V785.817",
    stroke: "#694A4A",
    strokeWidth: 0.654481
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7971 -77.1694V785.817",
    stroke: "#694A4A",
    strokeWidth: 0.654481
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.684 -77.1694V785.817",
    stroke: "#694A4A",
    strokeWidth: 0.654481
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.571 -77.1694V785.817",
    stroke: "#694A4A",
    strokeWidth: 0.654481
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.457 -77.1694V785.817",
    stroke: "#694A4A",
    strokeWidth: 0.654481
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.344 -77.1694V785.817",
    stroke: "#694A4A",
    strokeWidth: 0.654481
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.231 -77.1694V785.817",
    stroke: "#694A4A",
    strokeWidth: 0.654481
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.118 -77.1694V785.817",
    stroke: "#694A4A",
    strokeWidth: 0.654481
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.005 -77.1694V785.817",
    stroke: "#694A4A",
    strokeWidth: 0.654481
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.891 -77.1694V785.817",
    stroke: "#694A4A",
    strokeWidth: 0.654481
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.778 -77.1694V785.817",
    stroke: "#694A4A",
    strokeWidth: 0.654481
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.665 -77.1694V785.817",
    stroke: "#694A4A",
    strokeWidth: 0.654481
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_446_7793)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-314.184 6.604L934 6.604",
    stroke: "#694A4A",
    strokeWidth: 0.654481
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-314.184 48.4907L934 48.4907",
    stroke: "#694A4A",
    strokeWidth: 0.654481
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-314.184 90.3777L934 90.3777",
    stroke: "#694A4A",
    strokeWidth: 0.654481
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-314.184 132.264L934 132.264",
    stroke: "#694A4A",
    strokeWidth: 0.654481
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-314.184 174.151L934 174.151",
    stroke: "#694A4A",
    strokeWidth: 0.654481
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-314.184 216.038L934 216.038",
    stroke: "#694A4A",
    strokeWidth: 0.654481
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-314.184 257.925L934 257.925",
    stroke: "#694A4A",
    strokeWidth: 0.654481
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-314.184 299.812L934 299.812",
    stroke: "#694A4A",
    strokeWidth: 0.654481
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-314.184 341.698L934 341.698",
    stroke: "#694A4A",
    strokeWidth: 0.654481
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-314.184 383.585L934 383.585",
    stroke: "#694A4A",
    strokeWidth: 0.654481
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-314.184 425.472L934 425.472",
    stroke: "#694A4A",
    strokeWidth: 0.654481
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-314.184 467.358L934 467.358",
    stroke: "#694A4A",
    strokeWidth: 0.654481
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-314.184 509.245L934 509.245",
    stroke: "#694A4A",
    strokeWidth: 0.654481
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_446_7793",
    x: -241,
    y: -505,
    width: 1456,
    height: 1456,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 225,
    result: "effect1_foregroundBlur_446_7793"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_diamond_446_7793",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(200 144.369) rotate(90) scale(376.812 876.393)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_446_7793"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 488,
    height: 594,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_446_7793"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1248.18,
    height: 806.841,
    fill: "white",
    transform: "translate(-314.184 -77.1694)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_446_7793"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1248.18,
    height: 806.841,
    fill: "white",
    transform: "translate(-314.184 -77.1694)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerShape);
export default __webpack_public_path__ + "static/media/BannerShape.4ce8ba0dc732505636d1486e9a15e6a7.svg";
export { ForwardRef as ReactComponent };